var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Curves-Levels-Graph--Streamline-Sharp",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Curves Levels Graph Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "curves-levels-graph"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 176559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1469",
    stroke: "#fff",
    strokeLinecap: "square",
    d: "M18.884 6.93c0 5.11 -4.161 9.254 -9.295 9.254",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 77",
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M17.069 3.299H20.7V6.93h-3.631z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 78",
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M5.958 14.369h3.631V18H5.958z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 176442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1387",
    stroke: "#fff",
    d: "m2 9.925 0 -3.15",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1388",
    stroke: "#fff",
    d: "m2 13.075 0 3.15",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1380",
    stroke: "#fff",
    d: "M2 18.85 2 22l3.15 0m8.925 0 3.15 0m-6.3 0h-3.15M23 22l-3.15 0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1381",
    stroke: "#fff",
    d: "m2 1 0 3.15",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluation);
export default __webpack_public_path__ + "static/media/EVALUATION.a90e61e9c06f7ebe0ed973a002287759.svg";
export { ForwardRef as ReactComponent };